import { LoadSpinner } from '@calizahq/react-components-v2'
import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { useTimeline } from '@/hooks/useTimeline'
import { TimelineTicket } from '@/types/Homes'
import { MobileTicketCard } from '@/views/Ticket/Tickets/MobileTicketCard'

import { HomeTicketListColumns } from './HomeTickets.data'

type Props = {
  homeId: number
}
export const HomeTickets = ({ homeId }: Props) => {
  const { isTablet } = useMobile()
  const { data: homeData, isLoading } = useTimeline({ id: homeId })

  const data = useMemo(() => {
    return homeData && homeData.home?.tickets ? homeData?.home?.tickets : []
  }, [homeData])

  const columns = useMemo(() => {
    return HomeTicketListColumns
  }, [])

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">Tickets</h2>
      </div>
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isTablet ? (
            <>
              {(data.length > 0 &&
                data.map((ticket, index) => (
                  <MobileTicketCard includeMarket={false} key={index} ticket={ticket as TimelineTicket} />
                ))) || <NoResults />}
            </>
          ) : (
            <Table columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
